import React, { useContext, useEffect, useState } from "react";
import { TeamsSubMenu } from "../Teams/TeamsSubMenu";
import { TeamItemTrial } from "../Teams/TeamItemTrial";
import { AppContext } from "../../context/app/appContext";
import { TopBar } from "../common/TopBar";
import { Sidebar } from "../common/Sidebar";
import { Button, Confirm, Dimmer, Loader, Modal } from "semantic-ui-react";
import axios from "axios";
import TeamDetails from '../Teams/TeamDetails';
import { useFormik } from "formik";
import { FreeTrialNewTeamFormValidationSchema } from "../../utilities/Validations";
import { TeamsPageEmployeeList } from '../Teams/TeamsPageEmployeeList';
import { Route, Switch, useHistory, useParams } from 'react-router-dom';
import { addSingleEmployeeFormValidationSchema } from "../../utilities/Validations";

export const TeamsPageTrial = (props) => {

    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    const accessToken = localStorage.getItem('accessToken');
    let API = axios.create({ baseURL, headers: { 'Authorization': `Bearer ${accessToken}` }, });
    const history = useHistory();
    const dimmer = 'blurring';

    const appContext = useContext(AppContext);
    const [teams, setTeams] = useState([]);
    const [newTeamId, setNewTeamId] = useState(0);
    const [clickTeamName, setClickTeamName] = useState(null);

    /*const [newTeamName, setNewTeamName] = useState('');
    const [newTeamBudget, setNewTeamBudget] = useState(0);
    const [newTeamExpense, setNewTeamExpense] = useState(0);*/

    const [showNewTeamInlineForm, setShowNewTeamInlineForm] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [infoModalText, setInfoModalText] = useState('');

    const [selectTeam, setSelectTeam] = useState(null)

    const [currentlyEditingTeamId, setCurrentlyEditingTeamId] = useState('');
    const [teamIdToDelete, setTeamIdToDelete] = useState('');

    const [totalBudget, setTotalBudget] = useState(0);
    const [totalOfExpenseLimits, setTotalOfExpenseLimits] = useState(0);
    const [totalEmployeesCount, setTotalEmployeesCount] = useState(0);

    const [showConfirmTeamDeleteModal, setShowConfirmTeamDeleteModal] = useState(false);

    const [employeesToDisplay, setEmployeesToDisplay] = useState(null)
    const [currPage, setCurrPage] = useState('team')

    const [showAddSingleEmployeeModal, setShowAddSingleEmployeeModal] = useState(false);

    useEffect(() => {
        setTeams(appContext.teams);
        if (appContext.teams.length) {
            setSelectTeam(appContext.teams[0].id)
        }
        console.info({ teams });
        // eslint-disable-next-line
    }, [appContext.teams]);

    useEffect(() => {
        (async function loadTeams() {
            await appContext.loadTeams();
            await appContext.setEmployees();
        })();
        // eslint-disable-next-line
    }, []);

    // useEffect(() => {
    //     console.info({history})
    //     if(history.action === 'POP'){
    //         history.action = 'none'
    //         if(currPage === 'team')
    //             setClickTeamName(null)
    //     }
    // })

    useEffect(() => {
        if (teams.length && appContext.employees.length) {
            setEmployeesToDisplay(appContext.employees.filter(employee => { return employee.teamId === selectTeam }))
        }
        // eslint-disable-next-line
    }, [teams, appContext.employees, selectTeam]);

    useEffect(() => {
        setTotalBudget(teams.reduce((total, team) => {
            const teamSize = team.size === 0 ? 1 : team.size;
            // console.info({team});
            return total + (parseInt(team.budget) * parseInt(teamSize));
        }, 0));

        let expenseLimitTotal = 0;
        let employeeCount = 0;
        for (const team of teams) {
            expenseLimitTotal += parseFloat(team.expenseLimit);
            employeeCount += parseInt(team.size);
        }
        setTotalOfExpenseLimits(expenseLimitTotal);
        setTotalEmployeesCount(employeeCount);
    }, [teams]);

    const newTeamForm = useFormik({
        initialValues: {
            newTeamName: '',
            newTeamBudget: 0,
            newTeamExpenseLimit: 0,
        },
        validationSchema: FreeTrialNewTeamFormValidationSchema,
        onSubmit: async (values) => {
            console.log({ newTeamForm: values });
            await saveNewTeam();
        }
    });

    const saveNewTeam = async () => {
        console.info({
            newTeamId: newTeamId,
            newTeamName: newTeamForm.values.newTeamName,
            newTeamBudget: newTeamForm.values.newTeamBudget,
            newTeamExpense: newTeamForm.values.newTeamExpenseLimit,
        });



        await appContext.addTeam({
            name: newTeamForm.values.newTeamName,
            budget: newTeamForm.values.newTeamBudget,
            expenseLimit: newTeamForm.values.newTeamExpenseLimit,
        });
        newTeamForm.resetForm();
        setNewTeamId(0);
        setShowNewTeamInlineForm(false);

        try {
            const slackNewTeamCreated = await axios.post(
                `https://stgapi.perkfix.com/slack/message`,
                {
                    "email": "abelp915@gmail.com",
                    "message": `You have added team ${newTeamForm.values.newTeamName}`,
                }
            );
            console.log(slackNewTeamCreated)
        }
        catch (error) {
            console.info({ error })
        }
    };

    const addNewTeam = (e) => {
        newTeamForm.resetForm();
        setShowNewTeamInlineForm(true);
    };

    const cancelAddNewTeam = (e) => {
        newTeamForm.resetForm();
        setNewTeamId(0);
        setShowNewTeamInlineForm(false);
    };

    const handleTeamSelectionChange = (teamId, selected) => {
        const selectedTeams = teams.map(team => {
            if (team.id === teamId) return { ...team, selected: !selected }; // TODO: should be toggle
            return team;
        });
        console.clear();
        console.table(selectedTeams);
        setTeams(selectedTeams);
        setSelectTeam(teamId)
        setEmployeesToDisplay(appContext.employees.filter(employee => { return employee.teamId === teamId }))
    };

    const checkIfAlreadyEditing = (teamId) => {
        console.info(`checkIfAlreadyEditing teamId: ${teamId}`);
        if (currentlyEditingTeamId === '') {
            setCurrentlyEditingTeamId(teamId);
            return false;
        } else {
            setInfoModalText(`Please save or cancel current team updates.`);
            setShowInfoModal(true);
            return true;
        }
    }

    const handleResetEditInProgress = () => {
        setCurrentlyEditingTeamId('');
    }

    const handleCancelTeamDelete = (teamId) => {
        console.info(`canceled team delete... ${teamId}`);
        setShowConfirmTeamDeleteModal(false);
    };

    const handleConfirmTeamDelete = async () => {
        console.info(`confirmed team delete...`);
        appContext.setLoading();
        const response = await API.post(`/delete-team`, { id: teamIdToDelete, }).catch((error) => {
            console.info({ error });
            if (
                error.isAxiosError &&
                error.response.data &&
                error.response.data.status
            ) {
                console.info(error.response.data.status);
                const { code, message } = error.response.data.status;
                console.info({ code });
                setInfoModalText(message);
                setShowInfoModal(true);
                appContext.setLoading(false);
                return error.response.data.status;
            } else {
                setInfoModalText(`There was an error. Please try again later.`);
                setShowInfoModal(true);
                appContext.setLoading(false);
            }
        });
        if (response && response.data && response.data.status) {
            const { code, message } = response.data.status;
            console.info({ code, message });
            setInfoModalText(message);
            setShowInfoModal(true);
            if (code === `team/deleted`) appContext.deleteTeam(teamIdToDelete);
            appContext.setLoading(false);
        }
        setShowConfirmTeamDeleteModal(false);
    };

    const handleTeamDelete = (teamId) => {
        setTeamIdToDelete(teamId);
        console.info(`Deleting team with ID: ${teamId}`);
        setShowConfirmTeamDeleteModal(true);
    };

    const addSingleEmployeeForm = useFormik({
        initialValues: {
            newEmployeeFirstName: '',
            newEmployeeLastName: '',
            newEmployeeContactNumber: '',
            newEmployeeEmail: '',
        },
        validationSchema: addSingleEmployeeFormValidationSchema,
        onSubmit: async (values) => {
            // alert(JSON.stringify(values, null, 2));
            setShowAddSingleEmployeeModal(false);
            addSingleEmployeeForm.resetForm();
            const newId = await appContext.addEmployee({
                email: addSingleEmployeeForm.values.newEmployeeEmail,
                firstName: addSingleEmployeeForm.values.newEmployeeFirstName,
                lastName: addSingleEmployeeForm.values.newEmployeeLastName,
                contactNumber: addSingleEmployeeForm.values.newEmployeeContactNumber,
            });

            console.info({ newId })
            const addedToTeam = await appContext.addEmployeesToTeam([newId], selectTeam);
            console.info({ addedToTeam });
        },
    });

    const nextButtonClicked = (teamId) => {
        // setClickTeamName(team)
        // history.push(`/programs/teams/id`)
        // return <div>TEST</div>
        history.push(`/programs/teams/${teamId}`)
    }

    return (
        <div id="app" style={{ marginRight: 14, paddingRight: 0, overflowX: 'visible' }}>
            {appContext.loading && (<Dimmer active inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>)}
            {/* {clickTeamName == null ? */}
            <div className="ui grid" id="team-management">
                <div className="twelve wide column" style={{ marginRight: 0, paddingRight: 0 }}>
                    <div className="ui segment"
                        style={{ alignItems: 'center', width: '100%', backgroundColor: 'rgba(238, 241, 243, 1)', paddingTop: 5, paddingBottom: 5, marginBottom: 0, }}>
                        <div className="ui secondary  menu" style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'rgba(238, 241, 243, 1)' }}>
                            <div className="left menu" style={{ float: 'right', alignItems: 'center' }}>
                                {!showNewTeamInlineForm && (<div>
                                    <Button size="huge" onClick={addNewTeam} style={{ backgroundColor: 'transparent', fontSize: 18, color: 'rgba(0, 130, 244, 1)', fontStyle: 'SFProText-Medium' }}>+ Add New Team</Button>
                                </div>)}
                                {showNewTeamInlineForm && (<div className="item">
                                    <Button className="ui button" onClick={cancelAddNewTeam}>Cancel</Button>
                                </div>)}
                                {showNewTeamInlineForm ? (<div className="item">
                                    <Button className="ui button" onClick={saveNewTeam} disabled={newTeamForm.initialValues === newTeamForm.values || !newTeamForm.isValid}>Save
                                        </Button>
                                </div>) : ''}
                            </div>
                        </div>
                    </div>

                    {/* <table className="ui single line table teams center aligned"> */}
                    <table className="teams-table" style={{ width: '100%', backgroundColor: 'transparent', textAlign: 'center', marginTop: 5 }}>
                        <thead>
                            <tr style={{ fontStyle: 'SFProText-Regular', fontSize: 12 }}>
                                <th>Team Name</th>
                                <th>Budget</th>
                                <th>Expense Limit</th>
                                <th>Team Size</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>

                            {/* new Team... */}
                            {showNewTeamInlineForm && <tr className='table-row' style={{ fontStyle: 'SFProText-Medium', fontSize: 14, fontWeight: 900, backgroundColor: 'rgba(238, 241, 243, 1)' }}>
                                <td>
                                    <div className="ui error field">
                                        <div className="ui input">
                                            <input id="newTeamName" name="newTeamName" type="text" className="center aligned" placeholder="Team Name" value={newTeamForm.values.newTeamName}
                                                onChange={newTeamForm.handleChange}
                                                onBlur={newTeamForm.handleBlur} />
                                        </div>
                                        {newTeamForm.errors.newTeamName && newTeamForm.touched.newTeamName ? (
                                            <div className="error-message" role="alert" aria-atomic="true">{newTeamForm.errors.newTeamName}</div>) : ''}
                                    </div>
                                    <hr />

                                    {/*<section>
                                        <p>{`Object.keys(newTeamForm.touched).length : ${Object.keys(newTeamForm.touched).length}`}</p>
                                        <p>{`Object.keys(newTeamForm.errors).length : ${Object.keys(newTeamForm.errors).length}`}</p>
                                        <p>{JSON.stringify(newTeamForm.errors)}</p>
                                    </section>*/}
                                </td>
                                <td>
                                    <div className="ui error field" style={{}}>
                                        <div className="ui input">
                                            <input id="newTeamBudget" name="newTeamBudget" className="collapsed center aligned" type="number" min="1" style={{ width: 150 }}
                                                value={newTeamForm.values.newTeamBudget} onChange={newTeamForm.handleChange}
                                                onBlur={newTeamForm.handleBlur} />
                                            <div className='per-month middle-centered'>/month</div>
                                        </div>
                                        {newTeamForm.errors.newTeamBudget && newTeamForm.touched.newTeamBudget ? (
                                            <div className="error-message" role="alert" aria-atomic="true">{newTeamForm.errors.newTeamBudget}</div>) : ''}
                                    </div>
                                </td>
                                <td>
                                    <div className="ui error field">
                                        <div className="ui input">
                                            <input id="newTeamExpenseLimit" name="newTeamExpenseLimit" className="collapsed center aligned" type="number" min="0" style={{ width: 150 }}
                                                value={newTeamForm.values.newTeamExpenseLimit} onChange={newTeamForm.handleChange}
                                                onBlur={newTeamForm.handleBlur} />
                                            <div className='per-month middle-centered'>/month</div>
                                        </div>
                                        {newTeamForm.errors.newTeamExpenseLimit && newTeamForm.touched.newTeamExpenseLimit ? (
                                            <div className="error-message" role="alert" aria-atomic="true">{newTeamForm.errors.newTeamExpenseLimit}</div>) : ''}
                                    </div>
                                </td>
                                {/*<td className='team-active-status'>Inactive</td>*/}
                                <td>-</td>
                                <td>-</td>
                            </tr>}

                            {teams.map(
                                team => {
                                    const { id, selected } = team;
                                    return (
                                        <TeamItemTrial key={id} {...team} teamData={team}
                                            selected={selected}
                                            selectTeam={selectTeam}
                                            setSelectTeam={setSelectTeam}
                                            onSelectionChange={handleTeamSelectionChange}
                                            // setClickTeamName={setClickTeamName}
                                            nextButtonClicked={nextButtonClicked}
                                            resetEditInProgress={handleResetEditInProgress}
                                            editInProgress={checkIfAlreadyEditing}
                                            onDelete={handleTeamDelete}
                                        />
                                    );
                                })}

                        </tbody>
                    </table>

                    {/* <footer className="ui three column grid" style={{width: '100%', marginRight: 0, paddingRight: 0}}>
                            <div className="column"><h5>Total Perk Budget: ${totalBudget}</h5></div>
                            <div className="column"><h5>Total Expense Limit: ${totalOfExpenseLimits}</h5></div>
                            <div className="column"><h5>Total Employees: {totalEmployeesCount}</h5></div>
                        </footer> */}
                </div>
                <div className="four wide column" style={{ paddingLeft: 5, marginLeft: 0, marginRight: 0, paddingRight: 0 }}>
                    {/* {selectTeam && appContext.teams.length && appContext.employees.length && employeesToDisplay ?
                        <> */}
                            <div className="ui segment" style={{ alignItems: 'center', width: '100%', backgroundColor: 'rgba(238, 241, 243, 1)', paddingTop: 5, paddingBottom: 5, marginBottom: 0 }}>
                                <div className="ui secondary  menu" style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'rgba(238, 241, 243, 1)' }}>
                                    <div className="left menu" style={{ float: 'right', alignItems: 'center' }}>
                                        <Button size="huge" disabled={!selectTeam || !appContext.teams.length} onClick={() => setShowAddSingleEmployeeModal(true)} style={{ backgroundColor: 'transparent', fontSize: 18, color: 'rgba(0, 130, 244, 1)', fontStyle: 'SFProText-Medium' }}>+ Add New Employee(s)</Button>
                                    </div>
                                </div>
                            </div>
                            {appContext.employees.length && employeesToDisplay ? 
                                <>
                                    <div style={{ height: 50, fontStyle: 'SFProText-Regular', fontSize: 14, fontWeight: '700', display: 'flex', alignItems: 'center' }}>
                                        Employees in team:
                                        </div>
                                    {employeesToDisplay.map((employee, index) => {
                                        return <TeamsPageEmployeeList key={index} employee={employee} />
                                    })}
                                </>
                            : null}
                            {/* <div style={{ height: 50, fontStyle: 'SFProText-Regular', fontSize: 14, fontWeight: '700', display: 'flex', alignItems: 'center' }}>
                                Employees in team:
                                </div>
                            {employeesToDisplay.map((employee, index) => {
                                return <TeamsPageEmployeeList key={index} employee={employee} />
                            })} */}
                        {/* </>
                        : null} */}

                </div>
            </div>
            {/* :
                <Switch>
                    <Route path={`/programs/teams/id`} ><TeamDetails teamData={clickTeamName} currPage={currPage} setCurrPage = {setCurrPage} /></Route>
                </Switch>
            } */}
            <Confirm className="confirm-modal" open={showConfirmTeamDeleteModal}
                content='Are you sure to delete this team?'
                cancelButton='Cancel'
                confirmButton="Delete"
                onCancel={handleCancelTeamDelete} onConfirm={handleConfirmTeamDelete} />

            <Modal dimmer={'blurring'} open={showInfoModal} size="mini">
                <Modal.Content><p>{infoModalText}</p></Modal.Content>
                <Modal.Actions className="center aligned"><Button onClick={e => setShowInfoModal(false)}>Ok</Button></Modal.Actions>
            </Modal>

            <Modal dimmer={dimmer} open={showAddSingleEmployeeModal}
                size="small" onClose={addSingleEmployeeForm.resetForm}>
                <Modal.Content><p>Import from your payroll provider</p>
                    <button className="ui button primary">Connect with Payroll Provider</button>
                    <h2>OR</h2>
                    <form className="ui form"
                        onSubmit={addSingleEmployeeForm.handleSubmit}>
                        <div className="ui field fluid">Employee Details</div>
                        <div className="ui two wide fields">
                            <div className={`field ${addSingleEmployeeForm.errors.newEmployeeFirstName && addSingleEmployeeForm.touched.newEmployeeFirstName ? 'error' : ''}`}><input
                                required type="text"
                                className="ui input"
                                placeholder="First Name"
                                name="newEmployeeFirstName"
                                id="newEmployeeFirstName"
                                value={addSingleEmployeeForm.values.newEmployeeFirstName}
                                onChange={addSingleEmployeeForm.handleChange} onBlur={addSingleEmployeeForm.handleBlur} />
                                <div className="error-message">{addSingleEmployeeForm.touched.newEmployeeFirstName ? addSingleEmployeeForm.errors.newEmployeeFirstName : ''}</div>
                            </div>
                            <div className={`field ${addSingleEmployeeForm.errors.newEmployeeLastName && addSingleEmployeeForm.touched.newEmployeeLastName ? 'error' : ''}`}>
                                <input required
                                    type="text"
                                    className="ui input"
                                    placeholder="Last Name"
                                    name='newEmployeeLastName'
                                    id='newEmployeeLastName'
                                    value={addSingleEmployeeForm.values.newEmployeeLastName}
                                    onChange={addSingleEmployeeForm.handleChange}
                                    onBlur={addSingleEmployeeForm.handleBlur} />
                                <div className="error-message">{addSingleEmployeeForm.touched.newEmployeeLastName ? addSingleEmployeeForm.errors.newEmployeeLastName : ''}</div>
                            </div>
                        </div>
                        <div className="ui two wide fields">
                            <div className={`field ${addSingleEmployeeForm.errors.newEmployeeContactNumber && addSingleEmployeeForm.touched.newEmployeeContactNumber ? 'error' : ''}`}>
                                <input required type="text"
                                    className="ui input"
                                    placeholder="Contact Number"
                                    name='newEmployeeContactNumber'
                                    id='newEmployeeContactNumber'
                                    value={addSingleEmployeeForm.values.newEmployeeContactNumber}
                                    onChange={addSingleEmployeeForm.handleChange} onBlur={addSingleEmployeeForm.handleBlur} />
                                <div
                                    className="error-message">{addSingleEmployeeForm.touched.newEmployeeContactNumber ? addSingleEmployeeForm.errors.newEmployeeContactNumber : ''}</div>
                            </div>
                            <div className={`field ${addSingleEmployeeForm.errors.newEmployeeEmail && addSingleEmployeeForm.touched.newEmployeeEmail ? 'error' : ''}`}>
                                <input required
                                    type="text"
                                    className="ui input"
                                    placeholder="Work email"
                                    name='newEmployeeEmail'
                                    id='newEmployeeEmail'
                                    value={addSingleEmployeeForm.values.newEmployeeEmail}
                                    onChange={addSingleEmployeeForm.handleChange}
                                    onBlur={addSingleEmployeeForm.handleBlur} />
                                <div className="error-message">{addSingleEmployeeForm.touched.newEmployeeEmail ? addSingleEmployeeForm.errors.newEmployeeEmail : ''}</div>
                            </div>
                        </div>
                        <br />

                        <div className="ui two wide fields">
                            <div className="field">
                                <Button className="right floated" type="button" onClick={() => setShowAddSingleEmployeeModal(false)}>Cancel</Button>
                            </div>
                            <div className="field">
                                <Button className="left floated" type="submit" disabled={Object.keys(addSingleEmployeeForm.touched).length === 0 ||
                                    Object.keys(addSingleEmployeeForm.errors).length > 0}>Create Profile</Button>
                            </div>
                        </div>
                    </form>
                </Modal.Content>
            </Modal>
        </div>
    );
};
